import { UPLOAD_TYPE } from './define';
import * as utils from './utils';
import { getIpInfo } from './ip';
import { getFingerPrint } from './finger';
import time from './time';
import { getSessionInfo } from './sessionId';
import { updateCommonParamsInfo, getCommonParamsInfo } from './commonParam';
import { isNumber } from '@utiles/index';
import { updateObjScidAndCidOnStoreResult } from '@utiles/storeHandleCid';
import { updateObjScidAndCidOnPwa } from '@utiles/pwa';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
const excUpload = (url, data, useGet = false, forceSendBeacon = false) => {
  // 如果data.game_id不是数字，不上报
  if (data?.game_id && !isNumber(data.game_id)) {
    return;
  }
  // 如果data.package_name包含斜杆，反斜杠，将其替换为空
  const SLASH_REGEX = /[\\/]/g;
  const fields = ['package_name', 'packageName'];
  fields.forEach(field => {
    if (data?.[field] && SLASH_REGEX.test(data[field])) {
      data[field] = data[field].replace(SLASH_REGEX, '');
    }
  });

  // 强制使用 sendBeacon 或者正常判断使用 sendBeacon
  const shouldUseSendBeacon =
    forceSendBeacon ||
    (navigator.sendBeacon &&
      Object.prototype.toString.call(navigator.sendBeacon) ==
        '[object Function]' &&
      !useGet);

  if (shouldUseSendBeacon && navigator.sendBeacon) {
    const params = new URLSearchParams();
    for (let key in data) {
      // post上报不需要编码
      params.append(key, String(data[key]));
    }
    navigator.sendBeacon(url, params);
  } else {
    let img = new Image();
    img.src = utils.getAjaxLink(url, data);
  }
};

const webstorev35Upload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  // 支付页pwa的scid处理
  data = updateObjScidAndCidOnPwa(data);
  data = updateObjScidAndCidOnStoreResult(data);
  let _time = time();
  let fingerTxt = await getFingerPrint();
  // const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url = 'https://gcollectsecond.octlib.com/webstore/collectData';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  let params = {
    ptcode: utils.getPlatform(),
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(),
    pay_page_id: 'webstore_v3.5',
    url: window.location.href,
    title: document.title?.trim() || '',
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || '',
    session_number: sessionInfo?.sount || '',
    uid: data?.uid || commonParamStorage?.uid || '',
    login_account: data?.loginAccount || commonParamStorage?.loginAccount || '',
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime,
    event_date: data?.pointDate || _time.pointDate,
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    // ip: ipInfo?.ip || '',
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || '',
    cid:
      data?.cid || commonParamStorage?.cid || utils.getUrlParams('cid') || '',
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams('scid') ||
      '',
    browser_user_agent: navigator.userAgent,
    logger: '平台前端',
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '',
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '',
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_value: eventValue || '', //事件值
    ...getGlobalGetLinkParams()
  };
  const globalLinkParams = getGlobalGetLinkParams();
  if (Object.keys(globalLinkParams || {}).length) {
    Object.keys(globalLinkParams || {}).forEach(key => {
      if (data[key]) {
        params[key] = data[key];
      }
    });
  }
  excUpload(url, params, false, forceSendBeacon);
};

const webstorev3Upload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  // 支付页pwa的scid处理
  data = updateObjScidAndCidOnPwa(data);
  data = updateObjScidAndCidOnStoreResult(data);
  let _time = time();
  let fingerTxt = await getFingerPrint();
  // const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url = 'https://gcollectsecond.octlib.com/webstore/collectData';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  let params = {
    ptcode: utils.getPlatform(),
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(),
    pay_page_id: 'webstore_v3',
    url: window.location.href,
    title: document.title?.trim() || '',
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || '',
    session_number: sessionInfo?.sount || '',
    uid: data?.uid || commonParamStorage?.uid || '',
    login_account: data?.loginAccount || commonParamStorage?.loginAccount || '',
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime,
    event_date: data?.pointDate || _time.pointDate,
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    // ip: ipInfo?.ip || '',
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || '',
    cid:
      data?.cid || commonParamStorage?.cid || utils.getUrlParams('cid') || '',
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams('scid') ||
      '',
    browser_user_agent: navigator.userAgent,
    logger: '平台前端',
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '',
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '',
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_value: eventValue || '', //事件值
    ...getGlobalGetLinkParams()
  };
  const globalLinkParams = getGlobalGetLinkParams();
  if (Object.keys(globalLinkParams || {}).length) {
    Object.keys(globalLinkParams || {}).forEach(key => {
      if (data[key]) {
        params[key] = data[key];
      }
    });
  }
  excUpload(url, params, false, forceSendBeacon);
};

const webstorev2Upload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  // 支付页pwa的scid处理
  data = updateObjScidAndCidOnPwa(data);
  data = updateObjScidAndCidOnStoreResult(data);
  let _time = time();
  let fingerTxt = await getFingerPrint();
  // const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url = 'https://gcollectsecond.octlib.com/webstore/collectData';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  let params = {
    ptcode: utils.getPlatform(),
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(),
    pay_page_id: 'webstore_v2',
    url: window.location.href,
    title: document.title?.trim() || '',
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || '',
    session_number: sessionInfo?.sount || '',
    uid: data?.uid || commonParamStorage?.uid || '',
    login_account: data?.loginAccount || commonParamStorage?.loginAccount || '',
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime,
    event_date: data?.pointDate || _time.pointDate,
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    // ip: ipInfo?.ip || '',
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || '',
    cid:
      data?.cid || commonParamStorage?.cid || utils.getUrlParams('cid') || '',
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams('scid') ||
      '',
    browser_user_agent: navigator.userAgent,
    logger: '平台前端',
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '',
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '',
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_value: eventValue || '', //事件值
    ...getGlobalGetLinkParams()
  };
  const globalLinkParams = getGlobalGetLinkParams();
  if (Object.keys(globalLinkParams || {}).length) {
    Object.keys(globalLinkParams || {}).forEach(key => {
      if (data[key]) {
        params[key] = data[key];
      }
    });
  }
  excUpload(url, params, false, forceSendBeacon);
};

const webstorev1Upload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  // 支付页pwa的scid处理
  data = updateObjScidAndCidOnPwa(data);
  data = updateObjScidAndCidOnStoreResult(data);
  let _time = time();
  let fingerTxt = await getFingerPrint();
  // const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url = 'https://gcollectsecond.octlib.com/webstore/collectData';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  const cid =
    data?.cid || commonParamStorage?.cid || utils.getUrlParams('cid') || '';
  const ptcode = utils.getPlatform();
  // 江美h5打点不上报
  if (ptcode == 'jp' && cid == 'h5') {
    return;
  }
  let params = {
    ptcode: ptcode,
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(),
    pay_page_id: 'webstore_v1',
    url: window.location.href,
    title: document.title?.trim() || '',
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || '',
    session_number: sessionInfo?.sount || '',
    uid: data?.uid || commonParamStorage?.uid || '',
    login_account: data?.loginAccount || commonParamStorage?.loginAccount || '',
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime,
    event_date: data?.pointDate || _time.pointDate,
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    // ip: ipInfo?.ip || '',
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || '',
    cid: cid,
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams('scid') ||
      '',
    browser_user_agent: navigator.userAgent,
    logger: '平台前端',
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '',
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '',
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_value: eventValue || '', //事件值
    event_reward: data?.eventReward || '', // 增加奖励字段
    ...getGlobalGetLinkParams()
  };
  const globalLinkParams = getGlobalGetLinkParams();
  if (Object.keys(globalLinkParams || {}).length) {
    Object.keys(globalLinkParams || {}).forEach(key => {
      if (data[key]) {
        params[key] = data[key];
      }
    });
  }
  excUpload(url, params, false, forceSendBeacon);
};

const webstoreUpload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  // 支付页pwa的scid处理
  data = updateObjScidAndCidOnPwa(data);
  data = updateObjScidAndCidOnStoreResult(data);
  let _time = time();
  let fingerTxt = await getFingerPrint();
  // const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url = 'https://gcollectsecond.octlib.com/webstore/collectData';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  const cid =
    data?.cid || commonParamStorage?.cid || utils.getUrlParams('cid') || '';
  const ptcode = utils.getPlatform();
  // 江美h5打点不上报
  if (ptcode == 'jp' && cid == 'h5') {
    return;
  }
  let params = {
    ptcode: ptcode,
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(),
    pay_page_id: 'sdkstore',
    url: window.location.href,
    title: document.title?.trim() || '',
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || '',
    session_number: sessionInfo?.sount || '',
    uid: data?.uid || commonParamStorage?.uid || '',
    login_account: data?.loginAccount || commonParamStorage?.loginAccount || '',
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime,
    event_date: data?.pointDate || _time.pointDate,
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    // ip: ipInfo?.ip || '',
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || '',
    cid: cid,
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams('scid') ||
      '',
    browser_user_agent: navigator.userAgent,
    logger: '平台前端',
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '',
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '',
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_value: eventValue || '', //事件值
    ...getGlobalGetLinkParams()
  };
  const globalLinkParams = getGlobalGetLinkParams();
  if (Object.keys(globalLinkParams || {}).length) {
    Object.keys(globalLinkParams || {}).forEach(key => {
      if (data[key]) {
        params[key] = data[key];
      }
    });
  }
  excUpload(url, params, false, forceSendBeacon);
};

const creditPayUpload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  let _time = time();
  let fingerTxt = await getFingerPrint();
  // const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url = 'https://gcollectsecond.octlib.com/webstore/collectData';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  let params = {
    ptcode: utils.getPlatform(),
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(),
    pay_page_id: 'creditpay',
    url: window.location.href,
    title: document.title?.trim() || '',
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || '',
    session_number: sessionInfo?.sount || '',
    uid: data?.uid || commonParamStorage?.uid || '',
    login_account: data?.loginAccount || commonParamStorage?.loginAccount || '',
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime,
    event_date: data?.pointDate || _time.pointDate,
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    // ip: ipInfo?.ip || '',
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || '',
    cid:
      data?.cid || commonParamStorage?.cid || utils.getUrlParams('cid') || '',
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams('scid') ||
      '',
    browser_user_agent: navigator.userAgent,
    logger: '平台前端',
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '',
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '',
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_value: eventValue || '', //事件值
    ...getGlobalGetLinkParams()
  };
  excUpload(url, params, false, forceSendBeacon);
};

const officialPassportUpload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  let _time = time();
  let fingerTxt = await getFingerPrint();
  const ipInfo = await getIpInfo();
  // const sessionInfo = getSessionInfo();
  // const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url =
    'https://gcollectsecond.octlib.com/sdkUIData/collectData?apikey=c42b641db90752b2597adc9536eb8cf7';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount || utils.getUrlParams('loginAccount') || '',
    uid: data.uid || utils.getUrlParams('uid') || '',
    roleName: data.roleName || utils.getUrlParams('roleName') || '',
    roleId: data.roleId || utils.getUrlParams('roleId') || '',
    serverId: data.serverId || utils.getUrlParams('serverId') || '',
    packageName: data.packageName || utils.getUrlParams('packageName') || '',
    devicePlate: data.devicePlate || utils.getUrlParams('devicePlate') || '',
    cid: data.cid,
    scid: data.scid,
    language:
      data.language ||
      utils.getUrlParams('appLanguage') ||
      utils.getUrlParams('language') ||
      ''
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  const commonParamStorage = getCommonParamsInfo();
  let params = {
    ptcode: 'global', // 平台标识
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(), // 游戏ID
    uid: data?.uid || commonParamStorage?.uid || '', // 用户ID
    login_account: decodeURIComponent(
      data?.loginAccount || commonParamStorage?.loginAccount || ''
    ), // 登陆账号
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime, // 事件上报时间
    event_date: data?.pointDate || _time.pointDate, // 上报日期
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_reward: data?.eventReward || '', // 事件奖励
    event_value: eventValue || '', //事件值
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '', // 应用包名
    package_version:
      commonParamStorage?.packageVersion ||
      utils.getUrlParams('packageVersion') ||
      '', // 包版本号 4.1.6.4
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '', // 操作系统
    os_version:
      commonParamStorage?.osVersion || utils.getUrlParams('osVersion') || '', // 操作系统版本
    phone_model:
      commonParamStorage?.phoneModel || utils.getUrlParams('phoneModel') || '', // 手机型号 iPhone XR
    ip: ipInfo?.ip || '', // ip地址
    url: window.location.href,
    title: data?.title || 'official_passport',
    user_fingerprint: fingerTxt,
    browser_user_agent: navigator.userAgent,
    language_device: data?.language || commonParamStorage?.language || '', // 设备语言
    sdk_version:
      commonParamStorage?.sdkVersion || utils.getUrlParams('sdkVersion') || '', // sdk版本
    gpid: data?.gpid || utils.getUrlParams('gpid') || '', // Google标识
    idfa:
      data?.idfa ||
      commonParamStorage?.idfa ||
      utils.getUrlParams('idfa') ||
      '', // IDFA标识
    afid:
      data?.afid ||
      commonParamStorage?.afid ||
      utils.getUrlParams('afid') ||
      '', // Appsflyer用户标识
    logger: '平台前端', // 打点标识
    ...getGlobalGetLinkParams()
  };
  excUpload(url, params, false, forceSendBeacon);
};

const officialSupportUpload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  let _time = time();
  let fingerTxt = await getFingerPrint();
  const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url = 'https://gcollectsecond.octlib.com/sdkUIData/collectData';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  let params = {
    ptcode: 'global', // 平台标识
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(), // 游戏ID
    page_type: 'CSOrder', // 工单上报日志类型
    url: window.location.href,
    title: document.title?.trim() || '',
    uid: data?.uid || commonParamStorage?.uid || '', // 用户ID
    login_account: decodeURIComponent(
      data?.loginAccount || commonParamStorage?.loginAccount || ''
    ), // 登陆账号
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime, // 事件上报时间
    event_date: data?.pointDate || _time.pointDate, // 上报日期
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    ip: ipInfo?.ip || '', // ip地址
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || '',
    cid:
      data?.cid || commonParamStorage?.cid || utils.getUrlParams('cid') || '',
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams('scid') ||
      '',
    browser_user_agent: navigator.userAgent,
    logger: '平台前端', // 打点标识
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '', // 应用包名
    package_version: utils.getUrlParams('packageVersion') || '', // 包版本号 4.1.6.4
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '', // 操作系统
    phone_model: utils.getUrlParams('phoneModel') || '', // 手机型号 iPhone XR
    language_device: data?.language || commonParamStorage?.language || '', // 设备语言
    sdk_version: commonParamStorage?.sdkVersion || '', // sdk版本
    gpid: utils.getUrlParams('gpid') || '', // Google标识
    idfa: utils.getUrlParams('idfa') || '', // IDFA标识
    afid: utils.getUrlParams('afid') || '', // Appsflyer用户标识
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || '',
    session_number: sessionInfo?.sount || '',
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_reward: data?.eventReward || '', // 事件奖励
    event_value: eventValue || '', //事件值
    ...getGlobalGetLinkParams()
  };
  excUpload(url, params, false, forceSendBeacon);
};

const passportUpload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  let _time = time();
  let fingerTxt = await getFingerPrint();
  const ipInfo = await getIpInfo();
  // const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url =
    'https://gcollectsecond.octlib.com/sdkUIData/collectData?apikey=c42b641db90752b2597adc9536eb8cf7';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  let params = {
    ptcode: 'global', // 平台标识
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(), // 游戏ID
    uid: data?.uid || commonParamStorage?.uid || '', // 用户ID
    login_account: decodeURIComponent(
      data?.loginAccount || commonParamStorage?.loginAccount || ''
    ), // 登陆账号
    url: window.location.href,
    title: 'passport',
    user_fingerprint: fingerTxt,
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime, // 事件上报时间
    event_date: data?.pointDate || _time.pointDate, // 上报日期
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_reward: data?.eventReward || '', // 事件奖励
    event_value: eventValue || '', //事件值
    browser_user_agent: navigator.userAgent,
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '', // 应用包名
    package_version: commonParamStorage?.packageVersion || '', // 包版本号 4.1.6.4
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '', // 操作系统
    os_version: commonParamStorage?.osVersion || '', // 操作系统版本
    phone_model: commonParamStorage?.phoneModel || '', // 手机型号 iPhone XR
    ip: ipInfo?.ip || '', // ip地址
    language_device: data?.language || commonParamStorage?.language || '', // 设备语言
    sdk_version: commonParamStorage?.sdkVersion || '', // sdk版本
    gpid: utils.getUrlParams('gpid') || '', // Google标识
    idfa: commonParamStorage?.idfa || '', // IDFA标识
    afid: commonParamStorage?.afid || '', // Appsflyer用户标识
    logger: '平台前端', // 打点标识
    ...getGlobalGetLinkParams()
  };
  excUpload(url, params, false, forceSendBeacon);
};
const webstorev0Upload = async (data = {}, forceSendBeacon = false) => {
  if (!Object.keys(data || {}).length) return;
  // 支付页pwa的scid处理
  data = updateObjScidAndCidOnPwa(data);
  data = updateObjScidAndCidOnStoreResult(data);
  let _time = time();
  let fingerTxt = await getFingerPrint();
  // const ipInfo = await getIpInfo();
  const sessionInfo = getSessionInfo();
  const commonParamStorage = getCommonParamsInfo();
  let eventValue = '';
  let url = 'https://gcollectsecond.octlib.com/webstore/collectData';

  let updateParams = {
    gameId: data.gameId,
    loginAccount: data.loginAccount,
    uid: data.uid,
    roleName: data.roleName,
    roleId: data.roleId,
    serverId: data.serverId,
    packageName: data.packageName,
    devicePlate: data.devicePlate,
    cid: data.cid,
    scid: data.scid,
    language: data.language
  };

  Object.keys(updateParams || {}).forEach(key => {
    if (updateParams[key] === null || updateParams[key] === undefined) {
      delete updateParams[key];
    }
  });

  if (Object.keys(updateParams || {}).length) {
    updateCommonParamsInfo(updateParams);
  }

  if (data.eventValue) {
    eventValue = JSON.stringify(data.eventValue);
  }

  let params = {
    ptcode: utils.getPlatform(),
    game_id: data?.gameId || commonParamStorage?.gameId || utils.getGameId(),
    pay_page_id: 'webstore_v0',
    url: window.location.href,
    title: document.title?.trim() || '',
    user_fingerprint: fingerTxt,
    session_id: sessionInfo?.sid || '',
    session_number: sessionInfo?.sount || '',
    uid: data?.uid || commonParamStorage?.uid || '',
    login_account: data?.loginAccount || commonParamStorage?.loginAccount || '',
    role_name: data?.roleName || commonParamStorage?.roleName || '',
    role_id: data?.roleId || commonParamStorage?.roleId || '',
    server_id: data?.serverId || commonParamStorage?.serverId || '',
    event_time: data?.pointTime || _time.pointTime,
    event_date: data?.pointDate || _time.pointDate,
    event_timestamp: data?.pointTimestamp || _time.pointTimestamp,
    os: utils.systemInfo,
    os_version: utils.getOsVersion(),
    device_type: utils.getOsModel(),
    // ip: ipInfo?.ip || '',
    browser_version: utils.getBrowserVerson(),
    browser_type: utils.getBrowserName(),
    language: data?.language || commonParamStorage?.language || '',
    cid:
      data?.cid || commonParamStorage?.cid || utils.getUrlParams('cid') || '',
    scid:
      data?.scid ||
      commonParamStorage?.scid ||
      utils.getUrlParams('scid') ||
      '',
    browser_user_agent: navigator.userAgent,
    logger: '平台前端',
    package_name:
      data?.packageName ||
      commonParamStorage?.packageName ||
      utils.getUrlParams('packageName') ||
      '',
    device_plate:
      data?.devicePlate ||
      commonParamStorage?.devicePlate ||
      utils.getUrlParams('devicePlate') ||
      '',
    event_name: data?.eventName || '', //事件名称
    event_is_first: data?.eventIsFirst || '', //事件首次行为
    event_type: data?.eventType || '', //事件类型
    event_reason: data?.eventReason || '', //事件原因
    event_value: eventValue || '', //事件值
    ...getGlobalGetLinkParams()
  };
  const globalLinkParams = getGlobalGetLinkParams();
  if (Object.keys(globalLinkParams || {}).length) {
    Object.keys(globalLinkParams || {}).forEach(key => {
      if (data[key]) {
        params[key] = data[key];
      }
    });
  }
  excUpload(url, params, false, forceSendBeacon);
};

export const getUploadFn = async fnType => {
  switch (fnType) {
    case UPLOAD_TYPE.webstorev35: {
      return webstorev35Upload;
    }
    case UPLOAD_TYPE.webstorev3: {
      return webstorev3Upload;
    }
    case UPLOAD_TYPE.webstorev2: {
      return webstorev2Upload;
    }
    case UPLOAD_TYPE.webstorev1: {
      return webstorev1Upload;
    }
    case UPLOAD_TYPE.creditpay: {
      return creditPayUpload;
    }
    case UPLOAD_TYPE.officialPassport:
    case UPLOAD_TYPE.dma: {
      return officialPassportUpload;
    }
    case UPLOAD_TYPE.csorder: {
      return officialSupportUpload;
    }
    case UPLOAD_TYPE.passport: {
      return passportUpload;
    }
    case UPLOAD_TYPE.sdkstore: {
      return webstoreUpload;
    }
    case UPLOAD_TYPE.webstorev0: {
      return webstorev0Upload;
    }
    default:
      return data => {
        console.log(data);
      };
  }
};
